import React, { Fragment, useEffect } from "react";
import ReactDOM from "react-dom";
import { translate } from "../Services/translation";
import ProductPrice from "./ProductPrice";
import BuyButton from "./BuyButton";
import { Provider } from "react-redux"; // Import Provider
import BuyButtonContainer from "../Containers/BuyButton.container";

const ProductCard = ({ productItem, index, store }) => {
  const product = JSON.parse(productItem.product);
  return (
    <div
      className="product-detail__product-box product-list__item columns"
      data-item-id={product.articleNumber}
      key={`product-slider-banner-${index}`}
    >
      <a href={product.url} itemProp="url" title={product.name}>
        <div className="product__container">
          <Fragment>
            <figure className="product__tag">
              {productItem.tagImage && (
                <div
                  className="product__tag-image"
                  dangerouslySetInnerHTML={{ __html: productItem.tagImage }}
                ></div>
              )}
            </figure>
            <figure className="product__figure">
              {productItem.image ? (
                <div
                  className="product__image-link"
                  dangerouslySetInnerHTML={{ __html: productItem.image }}
                ></div>
              ) : (
                translate("product.noproductimage")
              )}
            </figure>
          </Fragment>
          {product.isRelatedProducts ? (
            <div className="product__info">
              <h3 itemProp="name" className="product__name">
                {product.longDescription}
              </h3>
              <span className="product__articlenumber">
                {" "}
                {translate("product.articlenumber")} {product.articleNumber}
              </span>
            </div>
          ) : (
            <div className="product__info">
              <h3 itemProp="name" className="product__name">
                {product.longDescription}
              </h3>
              <p className="product__info--description">
                {product.shortDescription}
              </p>
              <span className="product__articlenumber">
                {translate("product.articlenumber")} {product.articleNumber}
              </span>
            </div>
          )}

          <div className="product__info__bottom">
            {product.showStock ? (
              product.isSoftware ? (
                <p className="product-detail__stock-status product-detail__stock-status--in-stock product-page">
                  <span><i className="icon ion-md-checkmark checkout-cart__icon--ok"></i>
                  {product.softwareDownloadText}</span>
                </p>
              ) : product.isInIntStock == true ||
                product.isInExtStock == true ? (
                <p className="product-detail__stock-status product-detail__stock-status--in-stock">
                  <link
                    itemProp="availability"
                    href="https://schema.org/InStock"
                  />
                  <span className="product-detail__stock-status--delivery-time">
                    <i className="icon ion-md-checkmark checkout-cart__icon--ok"></i>{" "}
                    {product.stockDeliveryTimeDescription}
                  </span>
                  {product.storeStockDeliveryTimeDescription && (
                    <span className="product-detail__stock-status--store-info">
                      <i className="icon ion-md-checkmark checkout-cart__icon--ok"></i>{" "}
                      {product.storeStockDeliveryTimeDescription}
                    </span>
                  )}
                </p>
              ) : (
                <p className="product-detail__stock-status product-detail__stock-status--out-of-stock">
                  <link
                    itemProp="availability"
                    href="http://schema.org/OutOfStock"
                  />
                  <span className="product-detail__stock-status--delivery-time">
                    <i className="icon ion-md-time"></i>{" "}
                    {product.stockDeliveryTimeDescription}
                  </span>
                  {product.storeStockDeliveryTimeDescription && (
                    <span className="product-detail__stock-status--store-info">
                      <i className="icon ion-md-checkmark checkout-cart__icon--ok"></i>{" "}
                      {product.storeStockDeliveryTimeDescription}
                    </span>
                  )}
                </p>
              )
            ) : null}
          </div>
        </div>
      </a>

      <div className="right">
        {product.showPrice && (
          <div className="product__price">
            <ProductPrice price={product.price} isList={true} />
          </div>
        )}
        {product.showBuyButton && (
          <button
            className="buy-button"
            data-article-number={product.id}
            data-css-class="button buy-button product-detail__buy-button"
            data-href={product.url}
            data-quantity-field-id={product.quantityFieldId}
            data-show-label={product.showLabel}
          >
            <Provider store={store}>
              <BuyButtonContainer
                articleNumber={product.id}
                cssClass="button buy-button product-detail__buy-button"
                href={product.url}
                label={null}
                quantityFieldId={product.quantityFieldId}
                showLabel={product.showLabel}
                isInStock={product.isInStock}
              />
            </Provider>
          </button>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
